var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.328 0H16V14.672C16 15.0347 15.872 15.344 15.616 15.6C15.36 15.8667 15.0453 16 14.672 16H1.328C0.965333 16 0.650667 15.8667 0.384 15.6C0.128 15.344 0 15.0347 0 14.672V1.328C0 0.954666 0.128 0.64 0.384 0.384C0.650667 0.128 0.965333 0 1.328 0ZM15.008 15.008V0.992H1.008V15.008H15.008ZM6.592 10.112L5.888 9.408L11.792 3.504H8C7.86133 3.504 7.744 3.456 7.648 3.36C7.552 3.25333 7.504 3.13067 7.504 2.992C7.504 2.85333 7.552 2.736 7.648 2.64C7.744 2.544 7.86133 2.496 8 2.496H13.504V8C13.504 8.13867 13.456 8.256 13.36 8.352C13.264 8.448 13.1467 8.496 13.008 8.496C12.8693 8.496 12.7467 8.448 12.64 8.352C12.544 8.256 12.496 8.13867 12.496 8V4.208L6.592 10.112Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.dfb5301fdcb3b4682fadeea2a6ffacf1.svg";
export { ForwardRef as ReactComponent };